import { createContext } from "react";

export interface CurrentUser {
  userId: string;
  userEmail: string;
  roles: string[];
  // Provider IDs assigned to this user, populated from GET /api/v1/me.
  // undefined = in-flight / retrying / unresolved; [] = /me succeeded with none.
  providerIds?: string[];
}

export interface CurrentUserContextValue {
  user: CurrentUser | null;
  /**
   * Re-fetches GET /me and updates providerIds (and roles/identity on Apps path).
   * Call after mutations that change the caller's authorized providers
   * (create provider, link/unlink user) so ProviderSelector stays fresh
   * without a full page reload.
   */
  refreshCurrentUser: () => Promise<void>;
}

const noopRefresh = async () => {};

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  user: null,
  refreshCurrentUser: noopRefresh,
});
